(function(){
  'use strict';

  var IMG_PANOLETA  = 'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/09-panoleta-regalo_3b765a37-2579-4128-805e-2c77fe5dd1ff.jpg?v=1782182574';
  var IMG_TARJETERO = 'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/08-tarjetero-sorpresa_99b55109-b0c7-467f-93ba-9828ae94d771.jpg?v=1782182570';

  // Imágenes únicas por variante (obtenidas directo de Shopify)
  var PRODUCTS = [
    // Billetera LV Pre Owner (DE PRIMERO)
    { name:'Billetera LV Pre Owner — Café',      img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/WhatsAppImage2025-04-25at2.24.59PM_1.jpg?v=1778085221', variantId:'47607450075354' },
    { name:'Billetera LV Pre Owner — Café Miel', img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/WhatsAppImage2025-04-25at2.24.59PM_2.jpg?v=1778085221', variantId:'47607450206426' },

    // Billetera Corner Coach
    { name:'Billetera Corner Coach — Caqui',         img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/ChatGPTImage5mar2026_15_16_25_61263a1e-52fd-4869-9d33-e6076da6d7cd.png?v=1778258804', variantId:'47612594389210' },
    { name:'Billetera Corner Coach — Apricot Negro',  img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/Gemini_Generated_Image_52morl52morl52mo_83161d9f-e765-40aa-b839-efe7221e1184.png?v=1778258610', variantId:'47794028085466' },
    { name:'Billetera Corner Coach — Negro',          img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/ChatGPTImage8may2026_11_42_05.png?v=1778258562', variantId:'47798708928730' },
    { name:'Billetera Corner Coach — Blanco',         img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/Gemini_Generated_Image_a7kg2ra7kg2ra7kg_e9bd36c1-9f5d-4c9b-82e6-df672456eaef.png?v=1778258610', variantId:'47845460508890' },

    // Billetera Karl Lagerfeld Relieve (Choupette kd003)
    { name:'Billetera Karl Lagerfeld Relieve — Beige', img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/ChatGPTImage8may2026_16_31_36.png?v=1778276104', variantId:'47607418192090' },
    { name:'Billetera Karl Lagerfeld Relieve — Negro', img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/ChatGPTImage8may2026_16_34_36.png?v=1778276104', variantId:'47607418224858' },

    // Billetera Marc Jacobs Snapshot
    { name:'Billetera Marc Jacobs Snapshot — Lila',   img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/WhatsAppImage2026-02-14at2.54.12PM_1.jpg?v=1778000788', variantId:'47607417864410' },
    { name:'Billetera Marc Jacobs Snapshot — Rosado', img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/50_d6602b19-7593-49f1-abe5-3fffe5f05892.webp?v=1749154628', variantId:'47607417929946' },

    // Billetera Prada Saffiano P.
    { name:'Billetera Prada Saffiano P. — Beige', img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/IMG_7952.webp?v=1751471847', variantId:'47607417700570' },
    { name:'Billetera Prada Saffiano P. — Negro', img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/IMG_7953.jpg?v=1751471851',  variantId:'47607417733338' },

    // Billetera Karl Lagerfeld Rue ST Guillaume
    { name:'Billetera Karl Lagerfeld Rue ST Guillaume — Beige', img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/Gemini_Generated_Image_hhftonhhftonhhft.png?v=1778199262', variantId:'47607418257626' },
    { name:'Billetera Karl Lagerfeld Rue ST Guillaume — Negro',  img:'https://cdn.shopify.com/s/files/1/0723/6222/9978/files/WhatsAppImage2025-11-12at7.30.37AM.jpg?v=1778199235',       variantId:'47607418290394' },
  ];

  var activeIndex = 0;
  var qty = 1;

  function renderSwatches(){
    var row = document.getElementById('sc-swatchRow');
    if(!row) return;
    row.innerHTML = PRODUCTS.map(function(p,i){
      return '<div class="sc-swatch'+(i===activeIndex?' active':'')+'" data-i="'+i+'" title="'+p.name+'"><img src="'+p.img+'" alt="'+p.name+'" loading="lazy"></div>';
    }).join('');
    row.querySelectorAll('.sc-swatch').forEach(function(el){
      el.addEventListener('click', function(){
        activeIndex = parseInt(el.dataset.i, 10);
        renderSwatches();
        renderMain();
      });
    });
  }

  function renderMain(){
    var p = PRODUCTS[activeIndex];
    var photo = document.getElementById('sc-productPhoto');
    if(photo) photo.innerHTML = '<img src="'+p.img+'" alt="'+p.name+'">';
    var nm = document.getElementById('sc-selName');
    if(nm) nm.textContent = p.name;
    updateBuyLinks();
  }

  function renderGifts(){
    var orbitT = document.querySelector('.sc-orbit.tarjetero');
    if(orbitT) orbitT.innerHTML = '<img src="'+IMG_TARJETERO+'" alt="Tarjetero sorpresa"><div class="sc-orbit-tag">Tarjetero sorpresa</div>';
    var orbitP = document.querySelector('.sc-orbit.panoleta');
    if(orbitP) orbitP.innerHTML = '<img src="'+IMG_PANOLETA+'" alt="Pañoleta de regalo"><div class="sc-orbit-tag">Pañoleta de regalo</div>';
    var gP = document.querySelector('.sc-gift-panoleta');
    if(gP) gP.innerHTML = '<img src="'+IMG_PANOLETA+'" alt="Pañoleta">';
    var gT = document.querySelector('.sc-gift-tarjetero');
    if(gT) gT.innerHTML = '<img src="'+IMG_TARJETERO+'" alt="Tarjetero">';
  }

  function buildCheckoutUrl(){
    var p = PRODUCTS[activeIndex];
    return '/cart/' + p.variantId + ':' + qty;
  }

  function updateBuyLinks(){
    var url = buildCheckoutUrl();
    document.querySelectorAll('.sc-buy-link').forEach(function(el){
      el.href = url;
    });
  }

  var qtyMinus = document.getElementById('sc-qtyMinus');
  var qtyPlus  = document.getElementById('sc-qtyPlus');
  if(qtyMinus) qtyMinus.addEventListener('click', function(){
    if(qty > 1){ qty--; document.getElementById('sc-qtyVal').textContent = qty; updateBuyLinks(); }
  });
  if(qtyPlus) qtyPlus.addEventListener('click', function(){
    qty++; document.getElementById('sc-qtyVal').textContent = qty; updateBuyLinks();
  });

  document.querySelectorAll('.sc-faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.sc-faq-item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.sc-faq-item').forEach(function(i){ i.classList.remove('open'); });
      if(!wasOpen) item.classList.add('open');
    });
  });

  var DURATION = 12*3600 + 45*60 + 30;
  var stored = sessionStorage.getItem('sc_countdown_end');
  var endTs;
  if(stored){ endTs = parseInt(stored, 10); }
  else { endTs = Date.now() + DURATION * 1000; sessionStorage.setItem('sc_countdown_end', endTs); }

  function paintCountdown(){
    var remaining = Math.max(0, Math.floor((endTs - Date.now()) / 1000));
    var h = String(Math.floor(remaining / 3600)).padStart(2,'0');
    var m = String(Math.floor((remaining % 3600) / 60)).padStart(2,'0');
    var s = String(remaining % 60).padStart(2,'0');
    ['sc-cdH','sc-cdH2'].forEach(function(id){ var el=document.getElementById(id); if(el) el.textContent=h; });
    ['sc-cdM','sc-cdM2'].forEach(function(id){ var el=document.getElementById(id); if(el) el.textContent=m; });
    ['sc-cdS','sc-cdS2'].forEach(function(id){ var el=document.getElementById(id); if(el) el.textContent=s; });
  }
  paintCountdown();
  setInterval(paintCountdown, 1000);

  renderSwatches();
  renderMain();
  renderGifts();

})();